import React, { useEffect } from 'react';
import TimerIcon from '@mui/icons-material/Timer';
import { addLeadingZero, formatTime } from '../../utils';
import { useTimer } from '../../pages/quiz/hooks'
import { ModalWrapper } from '../ModalWrapper';
import { ScreenTypes } from "../../store/quiz/quizSlice";
import { useQuiz, useQuizTimer } from '../../pages/quiz/hooks';


const Header = ({ activeQuestion, noOfQuestions, quiz, ended, testType, setAssessmentEnded }) => {
    const { result, setScreen, quizDetails } = useQuiz()
    const { timer, setTimer, setEndTime, showResult, showTimerModal, setShowResultModal, setShowTimerModal, setTimerStarted } = useQuizTimer()

    const handleModal = () => {
        setShowTimerModal(false);
        setShowResultModal(false);
        setScreen(ScreenTypes.Evaluating);

        if (setAssessmentEnded && typeof setAssessmentEnded === 'function') {
            setAssessmentEnded(true);
        }
    }

    const isTimed = () => Number(quizDetails.isTimed);

    useEffect(() => {
        if (isTimed()) {
            setTimer(quiz.totalTime);
        }
        setShowResultModal(false);
        setShowTimerModal(false);
        // console.log('quizDetails', quizDetails);

    }, []);

    useEffect(() => {
        if (ended && isTimed()) {
            // how long does it take to finish the quiz
            const timeTaken = quiz.totalTime - timer
            setEndTime(timeTaken)
            setShowResultModal(true);
        }
    }, [ended]);

    if (isTimed()) {
        useTimer(timer, quiz, setEndTime, setTimer, setShowTimerModal, showResult, setTimerStarted);
    }

    return (
        <React.Fragment>
            {/* <div style={styles.questionStats}>
                <div>
                    <span style={styles.activeQuestion}>{addLeadingZero(activeQuestion + 1)}</span>
                    <span style={styles.questionNumber}>/{addLeadingZero(noOfQuestions)}</span>
                </div>
                <div>
                    {isTimed() > 0 && !quiz?.preview && <div style={{ display: 'flex', alignItems: 'center', color: 'var(--mui-palette-primary-dark)' }}>
                        <TimerIcon />
                        <div style={{ marginLeft: '10px' }}>{formatTime(timer)}</div>
                    </div>}
                </div>
            </div> */}
            {
                // testType !== 'diagnostic-test-v2' ? (
                //     <ModalWrapper
                //         title={'Your time is up!'}
                //         subtitle={`You have attempted ${result.length} questions in total.`}
                //         onClick={handleModal}
                //         show={showResult || showTimerModal}
                //         handleClose={null}
                //     />
                // ) : 
                (showResult || showTimerModal ?
                    handleModal() : ''
                )}
        </React.Fragment>
    )
}

const styles = {
    activeQuestion: {
        fontSize: '20px',
        fontWeight: 600,
        color: 'var(--mui-palette-primary-orange)'
    },
    questionNumber: {
        fontSize: '20px',
        fontWeight: 600,
        color: 'var(--mui-palette-primary-light)',
    },
    questionStats: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '20px'
    }
}

export default Header
